import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import { AccordionSummary, AccordionSummaryProps } from '@mui/material'
import React from 'react'
import styled from 'styled-components'

export const AccordionTitle: React.FC<AccordionSummaryProps> = styled(
  (props: AccordionSummaryProps) => (
    <AccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '1rem' }} />}
      {...props}
    />
  ),
)(() => ({
  flexDirection: 'row-reverse',
  backgroundColor: '#F8F8F8',
  gap: '4px',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-root': {
    margin: 0,
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  '&.Mui-expanded': {
    borderBottom: '1px solid #ccc',
  },
}))
